import React from 'react';
import { CategoryType } from '../types';

import { formatLocalDate } from '@/utils/FormateLocalDate';
import { Icons } from '@/icons';

interface Props {
  category: CategoryType;
  onEdit(idx: string): void;
}

const CategoriesRow: React.FC<Props> = ({ category, onEdit }) => {
  return (
    <>
      <tr className='border-b'>
        <td className='p-4'>{category.name}</td>
        <td className='p-4 whitespace-nowrap'>
          {formatLocalDate(category.created_at)}
        </td>
        <td className='p-4'>
          <Icons.Edit onClick={() => onEdit(category.id)} />
        </td>
      </tr>
    </>
  );
};

export default CategoriesRow;
